import { ColumnDefinition } from "shared/components/UniversalTable/types/ColumnConfig";
import { CompanyEquipment, CompanyEquipmentType, EQUIPMENT_TYPE_LABELS } from "../types/companyEquipment";

export const COMPANY_EQUIPMENT_COLUMNS: ColumnDefinition[] = [
  {
    id: "id",
    label: "ID",
    sortKey: "id",
    minWidth: 80,
    defaultWeight: 1,
  },
  {
    id: "serialNumber",
    label: "Serienummer",
    sortKey: "serialNumber",
    minWidth: 180,
    defaultWeight: 3,
  },
  {
    id: "companyEquipmentType",
    label: "Type",
    sortKey: "companyEquipmentType",
    minWidth: 150,
    defaultWeight: 2,
  },
  {
    id: "company",
    label: "Bedrijf",
    sortKey: "company",
    minWidth: 200,
    defaultWeight: 3,
  },
  {
    id: "inUseBy",
    label: "In gebruik door",
    sortKey: "inUseBy",
    minWidth: 200,
    defaultWeight: 3,
  },
  {
    id: "actions",
    label: "",
    minWidth: 60,
    defaultWeight: 1,
  },
];

export const COMPANY_EQUIPMENT_FILTER_SECTIONS = [
  {
    key: "companyEquipmentType",
    label: "Type",
    options: Object.values(CompanyEquipmentType).map((type) => ({
      key: type,
      label: EQUIPMENT_TYPE_LABELS[type],
    })),
    color: "moss" as const,
    multiSelect: true,
  },
  {
    key: "company",
    label: "Bedrijf",
    options: [] as Array<{ key: string; label: string }>,
    color: "brick" as const,
    multiSelect: true,
    extractOptionsFromData: (rows: CompanyEquipment[]) => {
      if (!Array.isArray(rows)) return [];
      const companies = new Map<string, string>();
      rows.forEach((row) => {
        if (row.companyId && row.companyName) {
          companies.set(row.companyId, row.companyName);
        }
      });
      return Array.from(companies.entries()).map(([id, name]) => ({
        key: id,
        label: name,
      }));
    },
  },
];

export const COMPANY_EQUIPMENT_GROUPBY_OPTIONS = [
  { key: "none", label: "Geen" },
  {
    key: "companyEquipmentType",
    label: "Per type",
    extractor: (row: CompanyEquipment) =>
      row.companyEquipmentType
        ? EQUIPMENT_TYPE_LABELS[row.companyEquipmentType]
        : "Geen type",
  },
  {
    key: "company",
    label: "Per bedrijf",
    extractor: (row: CompanyEquipment) =>
      row.companyName || "Geen bedrijf",
  },
];
